module.exports = __webpack_public_path__ + "static/media/eye-off.b3d43364.svg";